import React from 'react';
import FieldForm from '../../FieldForm/FieldForm';
import { FieldTypeProps } from 'v2/common/DRM/CustomTab/Field/props';
import { FormControl } from 'react-bootstrap';

const DateField = (props: FieldTypeProps) => {
  const { fieldName, value } = props;

  return (
    <FieldForm
      {...props}
      content={value}
      renderInput={({ field }) => {
        return (
          <FormControl
            id={fieldName}
            data-cy={`tab-field-${fieldName}-input`}
            type="date"
            {...field}
          />
        );
      }}
    />
  );
};

export default DateField;
